export { default } from "./Image.js";
